import { getField, updateField } from 'vuex-map-fields';

export default {
  name: 'storageInfo',
  namespaced: true,
  state: {
    saved: false,
    recordId: undefined,
  },
  getters: {
    getField,
    storageInfo: (state) => state,
  },
  mutations: {
    updateField,
  },
};
